import React from "react";
import { useTranslation } from "react-i18next";
import { Eyebrow } from "../components/ui.jsx";
import { wireLinkStyles } from "./Privacy.jsx";

export default function CookiePolicy() {
  const { t } = useTranslation();
  const lifespanList = t("legal.cookiePolicy.lifespanList", { returnObjects: true });
  const tableRows = t("legal.cookiePolicy.tableRows", { returnObjects: true });

  return (
    <main>
      <section className="bg-wash">
        <div className="container" style={{ padding: "56px 24px 56px", maxWidth: 880 }}>
          <Eyebrow>{t("legal.eyebrow")}</Eyebrow>
          <h1 className="tt-h tt-h-xl" style={{ marginTop: 24 }}>{t("legal.cookiePolicy.title")}</h1>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.intro")} />
        </div>
      </section>

      <section style={{ padding: "8px 0 120px" }}>
        <div className="container" style={{ maxWidth: 820 }}>

          <Html as="p" style={prose} html={t("legal.cookiePolicy.company")} />

          <H2>{t("legal.cookiePolicy.whatH")}</H2>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.whatP1")} />
          <Html as="p" style={prose} html={t("legal.cookiePolicy.whatP2")} />

          <H2>{t("legal.cookiePolicy.lifespanH")}</H2>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.lifespanP1")} />
          <ul style={listStyle}>
            {lifespanList.map((li, i) => <Html key={i} as="li" html={li} />)}
          </ul>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.lifespanP2")} />

          <H2>{t("legal.cookiePolicy.usedH")}</H2>
          <div style={tableWrap}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>{t("legal.cookiePolicy.tableHeaders.name")}</th>
                  <th style={thStyle}>{t("legal.cookiePolicy.tableHeaders.category")}</th>
                  <th style={thStyle}>{t("legal.cookiePolicy.tableHeaders.purpose")}</th>
                  <th style={thStyle}>{t("legal.cookiePolicy.tableHeaders.lifespan")}</th>
                </tr>
              </thead>
              <tbody>
                {tableRows.map((row, i) => (
                  <tr key={i}>
                    <td style={tdStyle}>{row.name}</td>
                    <td style={tdStyle}>{row.category}</td>
                    <td style={tdStyle}>{row.purpose.split("\n\n").map((para, j) => (
                      <React.Fragment key={j}>
                        {j > 0 && <><br /><br /></>}
                        {para}
                      </React.Fragment>
                    ))}</td>
                    <td style={tdStyle}>{row.lifespan}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <H2>{t("legal.cookiePolicy.advertisingH")}</H2>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.advertisingNoteP")} />
          <Html as="p" style={prose} html={t("legal.cookiePolicy.advertisingThirdPartyP")} />

          <H2>{t("legal.cookiePolicy.socialH")}</H2>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.socialP")} />
          <ul style={listStyle}>
            <li>
              Facebook (<a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener" style={linkStyle}>https://www.facebook.com/privacy/policy/</a>)
            </li>
            <li>
              Instagram (<a href="https://help.instagram.com/519522125107875/?helpref=uf_share" target="_blank" rel="noopener" style={linkStyle}>https://help.instagram.com/519522125107875/?helpref=uf_share</a>)
            </li>
            <li>
              YouTube (<a href="https://www.youtube.com/howyoutubeworks/user-settings/privacy/" target="_blank" rel="noopener" style={linkStyle}>https://www.youtube.com/howyoutubeworks/user-settings/privacy/</a>)
            </li>
          </ul>

          <H2>{t("legal.cookiePolicy.turnOffH")}</H2>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.turnOffP1")} />
          <Html as="p" style={prose} html={t("legal.cookiePolicy.turnOffP2")} />
          <Html as="p" style={prose} html={t("legal.cookiePolicy.turnOffP3")} />
          <ul style={listStyle}>
            <li>
              <a href="https://support.google.com/chrome/answer/95647?hl=ro&p=cpn_cookies" target="_blank" rel="noreferrer noopener" style={linkStyle}>{t("legal.cookiePolicy.turnOffLinks.chrome")}</a>
            </li>
            <li>
              <a href="https://support.mozilla.org/ro/kb/activarea-si-dezactivarea-cookie-urilor" target="_blank" rel="noreferrer noopener" style={linkStyle}>{t("legal.cookiePolicy.turnOffLinks.firefox")}</a>
            </li>
            <li>
              <a href="https://support.microsoft.com/ro-ro/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noreferrer noopener" style={linkStyle}>{t("legal.cookiePolicy.turnOffLinks.ie")}</a>
            </li>
          </ul>
          <Html as="p" style={prose} html={t("legal.cookiePolicy.contactP")} />
        </div>
      </section>
    </main>
  );
}

function Html({ as: Tag = "p", html, style, className }) {
  return <Tag style={style} className={className} dangerouslySetInnerHTML={{ __html: wireLinkStyles(html) }} />;
}

const prose = {
  marginTop: 16,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760
};

const listStyle = {
  marginTop: 12,
  paddingLeft: 22,
  fontSize: 16,
  lineHeight: 1.7,
  color: "var(--ink-2)",
  maxWidth: 760,
  display: "flex",
  flexDirection: "column",
  gap: 10
};

const linkStyle = {
  color: "var(--persimmon)",
  textDecoration: "underline",
  textUnderlineOffset: 2
};

const tableWrap = {
  marginTop: 20,
  overflowX: "auto",
  maxWidth: 820
};

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: 15,
  lineHeight: 1.6,
  color: "var(--ink-2)",
  border: "1px solid var(--line)"
};

const thStyle = {
  textAlign: "left",
  padding: "12px 14px",
  fontFamily: "Satoshi, Inter, sans-serif",
  fontWeight: 700,
  fontSize: 14,
  letterSpacing: "-.005em",
  color: "var(--ink)",
  borderBottom: "1px solid var(--line)",
  borderRight: "1px solid var(--line)",
  background: "var(--wash, #faf7f2)",
  verticalAlign: "top"
};

const tdStyle = {
  padding: "12px 14px",
  borderBottom: "1px solid var(--line)",
  borderRight: "1px solid var(--line)",
  color: "var(--ink-2)",
  verticalAlign: "top"
};

function H2({ children }) {
  return (
    <h2
      className="tt-h tt-h-md"
      style={{ marginTop: 56, scrollMarginTop: 96 }}
    >
      {children}
    </h2>
  );
}
